<!--
CircularPlasticBadge
圆形塑料徽章
-->

<template>
  <transition name="el-fade-in-linear">
    <div>
      <el-collapse-item title="徽章 > 塑料 > 圆形塑料底" name="圆形塑料底">
        <el-row>
          <el-col :span="24">
            <el-form
              :label-position="labelPosition"
              :model="circularPlasticBadge"
              label-width="80px"
            >
              <el-form-item label="尺寸">
                <el-select v-model="circularPlasticBadge['尺寸']" placeholder="尺寸">
                  <el-option label="2.5cm" value="2.5cm"></el-option>
                  <el-option label="3.2cm" value="3.2cm"></el-option>
                  <el-option label="3.7cm" value="3.7cm"></el-option>
                  <el-option label="4.4cm" value="4.4cm"></el-option>
                  <el-option label="5.8cm" value="5.8cm"></el-option>
                  <el-option label="7.5cm" value="7.5cm"></el-option>
                  <el-option label="10cm" value="10cm"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="覆膜">
                <el-select v-model="circularPlasticBadge['覆膜']" placeholder="覆膜">
                  <el-option label="星幻膜" value="星幻膜"></el-option>
                  <el-option label="亚膜" value="亚膜"></el-option>
                  <el-option label="亮膜" value="亮膜"></el-option>
                  <el-option label="皮纹" value="皮纹"></el-option>
                  <el-option label="布纹" value="布纹"></el-option>
                  <el-option label="磨砂" value="磨砂"></el-option>
                  <el-option label="镭射星星" value="镭射星星"></el-option>
                  <el-option label="镭射闪点" value="镭射闪点"></el-option>
                  <el-option label="镭射爱心" value="镭射爱心"></el-option>
                  <el-option label="镭射蝴蝶" value="镭射蝴蝶"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="款式">
                <el-input v-model="circularPlasticBadge['款式']" placeholder="请填写您选择的款式"></el-input>
              </el-form-item>
              <el-form-item label="数量" :inline="true">
                <el-input-number v-model="circularPlasticBadge['数量']" :min="1" label="数量"></el-input-number>
              </el-form-item>
              <el-button v-on:click="addEvent()">提交</el-button> <el-button v-on:click="clear()">清空</el-button>
            </el-form>
          </el-col>
        </el-row>
      </el-collapse-item>
    </div>
  </transition>
</template>
<script>
export default {
  name: "CircularPlasticBadge",
  data() {
    return {
      forcollapse: ['allsame'],
      circularPlasticBadge: {
        title: "圆形塑料徽章",
        工艺: []
      },
      labelPosition: "left"
    };
  },
  methods: {
    addEvent() {
      this.$root.add(this.circularPlasticBadge);
       
    },
    clear() {
      this.$root.clearAlert()
      this.circularPlasticBadge = {
        title: "圆形塑料徽章",
        工艺: []
      };
    }
  }
};
</script>
<style scoped>
</style>